import { combineReducers, createStore } from "@reduxjs/toolkit";

import { persistStore, persistReducer } from "redux-persist";
import { rootSlice } from "./slice/rootSlice";

import storage from "redux-persist/lib/storage"; // Import storage from redux-persist/lib
// import { authentificationSlice } from "./slice/auth/AuthSlice";
import { companySlice } from "./slice/company/CompanySlice";
import { restaurantSlice } from "./slice/restaurant/RestaurantSlice";
import { modalLoginSlice } from "./slice/ModalLogin/ModalLoginSlice";
import { authentificationSlice } from "./slice/auth/AuthSlice";
import { orderSlice } from "./slice/order/OrderSlice";
import { promosSlice } from "./slice/promos/PromosSlice";
import { scrollSlice } from "./slice/scroll/ScrollSlice";
import { modalModeSlice } from "./slice/ModalMode/ModalMode";
import { modalStoresSlice } from "./slice/ModalStores/ModalStores";
import { ModalNotificationSlice } from "./slice/ModalNotification/ModalNotification";


export const ImageURI = "https://server.eatorder.fr:8000"


// export const ClientURI="https://localhost:8000/client"
// export const SseURI = "https://localhost:8000/sse"
// export const BaseURI="https://localhost:8000"

// export const ClientURI="https://192.168.1.40:8000/client"
// export const SseURI = "https://192.168.1.40:8000/sse"
// export const BaseURI="https://192.168.1.40:8000"


export const ClientURI = "https://server.eatorder.fr:8000/client"
export const SseURI = "https://server.eatorder.fr:8000/sse"
export const BaseURI = "https://server.eatorder.fr:8000"


// export const ClientURI = "https://test-server.eatorder.fr/client"
// export const SseURI = "https://test-server.eatorder.fr/sse"
// export const BaseURI = "https://test-server.eatorder.fr"

export const TestMode = false 
export const SaisieMode = true 

const persistConfig = {
  key: "root",
  storage: storage,
  // whitelist: ["root", 'company', "authentification", "restaurant", "order", "promos","modalMode"],
  whitelist: ["root", 'company', "authentification", "modalMode"],
};

const rootReducer = combineReducers({
  root: rootSlice.reducer,
  authentification: authentificationSlice.reducer,
  company: companySlice.reducer,
  restaurant: restaurantSlice.reducer,
  modalLogin: modalLoginSlice.reducer,
  order: orderSlice.reducer,
  promos: promosSlice.reducer,
  scroll: scrollSlice.reducer,
  modalMode: modalModeSlice.reducer,
  modalStores: modalStoresSlice.reducer,
  ModalNotification: ModalNotificationSlice.reducer,
});


const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  // Add the middleware here
);
export const persistor = persistStore(store);
